import dynamic from 'next/dynamic'

export const BentoRectangle = dynamic(() => import('./bento-rectangle'))
